// Import Ace and required files
import ace from "ace-builds/src-noconflict/ace";

export default ace;
